var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection2Icon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_320)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_50_320)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.40979 0H22.4098V22H0.40979V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4135 18.7156C12.0225 19.2595 12.7449 19.6609 13.5284 19.8908C14.3118 20.1207 15.1366 20.1732 15.9429 20.0447C16.7492 19.9161 17.5167 19.6097 18.1898 19.1476C18.8629 18.6855 19.4247 18.0793 19.8344 17.3731C20.2441 16.6669 20.4914 15.8783 20.5584 15.0646C20.6254 14.2508 20.5104 13.4324 20.2217 12.6687C19.9331 11.905 19.478 11.2151 18.8895 10.6491C18.301 10.0832 17.5939 9.65531 16.8195 9.39662M12.8655 12.6046C13.2677 13.6293 13.3531 14.7511 13.1108 15.8249C12.8684 16.8987 12.3094 17.8751 11.5061 18.6277C10.7028 19.3803 9.69209 19.8746 8.6048 20.0465C7.5175 20.2185 6.40363 20.0602 5.40728 19.5922C4.41093 19.1241 3.57795 18.3679 3.01609 17.4213C2.45424 16.4746 2.18936 15.3812 2.25574 14.2824C2.32211 13.1836 2.71668 12.13 3.3884 11.2579C4.06012 10.3858 4.97808 9.73532 6.02352 9.39062",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4098 12.7822C12.8685 12.7822 14.2674 12.2028 15.2989 11.1713C16.3303 10.1399 16.9098 8.74092 16.9098 7.28223C16.9098 5.82354 16.3303 4.42459 15.2989 3.39314C14.2674 2.36169 12.8685 1.78223 11.4098 1.78223C9.9511 1.78223 8.55215 2.36169 7.5207 3.39314C6.48925 4.42459 5.90979 5.82354 5.90979 7.28223C5.90979 8.74092 6.48925 10.1399 7.5207 11.1713C8.55215 12.2028 9.9511 12.7822 11.4098 12.7822Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.40979)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_50_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.40979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Icon1);
export default __webpack_public_path__ + "static/media/section2_icon1.ab3a3963c39c9ff666bdbab64db07d6e.svg";
export { ForwardRef as ReactComponent };